// import { createSelector } from '@reduxjs/toolkit';
// Models
import { RootState } from 'store';

export const selectPlayers = (state:RootState) => state.player.players;
export const selectFilter = (state:RootState) => state.player.filter;
export const selectLoading = (state:RootState) => state.player.loading;
